var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _a;
import React, { memo, useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { connect } from '../../store/connect';
import { APP_STATE, ECourseColumns } from '../../store/store';
import { getColumnHeaders, getDisplayColumns } from './courses-helpers';
import { CourseFilters } from './CourseFilters';
import { updatePageNumber, setAppState, resetBookData, setResolvedColumns } from '../../store/actions';
import { getBookEntities, getBookDataPaginatedResponse } from '../../store/actions/response.actions';
import { CourseTable } from './CourseTable';
import { CourseAccordion } from './CourseAccordion';
import { Pagination } from '../Pagination/Pagination';
import { CourseMeta } from '../CourseMeta/CourseMeta';
import { AppBootstrapComponent } from '../AppBootstrapComponent';
import { getBookManager } from '../../models/BookModel';
import { Loader } from '../Loader/Loader';
import { NoDataToDisplay } from '../NoDataToDisplay/NoDataToDisplay';
import { LoaderState } from '../../store/actions/loader.actions';
import { API_METHODS_ENUM } from '../../httpService';
import { scrollToRef } from '../../helpers';
import styled from 'styled-components';
import qs from 'querystring';
import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';
import assign from 'lodash/assign';
import { getBookDataResponseManager, isBookDataUpdated } from '../../models/BookModel/helpers';
import cancelToken from '../../cancelTokens';
import { useDebouncedQuery } from '../../hooks/useDebouncedQuery';
import { useIsCurrentState } from '../../hooks/appStateHooks';
import { useHadQuery } from '../../hooks/bookDataHooks';
import { useIsMobile } from '../../helpers/useIsMobile';
import { PoweredByWrapper } from '../PoweredBy';
var courseFactory = function (useShowCourseAccordion) {
    function mapStateToProps(state, _a) {
        var _b, _c, _d;
        var attributes = _a.attributes;
        var queryString = (state.appReducer || {}).queryString;
        var _e = (state.courseReducer || {}), disableInfo = _e.disableInfo, columns = _e.columns, fixedColumns = _e.fixedColumns, hasServerFilters = _e.hasServerFilters, allowedFilters = _e.allowedFilters, _f = _e.resolvedColumns, resolvedColumns = _f === void 0 ? null : _f, pageNumber = _e.pageNumber, pageSize = _e.pageSize, showSearchFilterAfter = _e.showSearchFilterAfter, additionalProps = _e.additionalProps;
        var bookData = getBookDataPaginatedResponse(state.responseReducer);
        var loaderState = new LoaderState(state.loaderReducer, { keys: [API_METHODS_ENUM.GET_BOOK_ENTITIES] });
        return {
            bookData: bookData,
            loading: loaderState.loading || !loaderState.loaded,
            errored: loaderState.errored,
            queryString: queryString,
            hasServerFilters: hasServerFilters,
            columns: columns,
            fixedColumns: fixedColumns,
            disableInfo: disableInfo,
            allowedFilters: allowedFilters,
            pageNumber: pageNumber,
            pageSize: pageSize,
            resolvedColumns: resolvedColumns,
            fixedCourses: (_b = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.fcourses) !== null && _b !== void 0 ? _b : '',
            fixedPlaces: (_c = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.fplaces) !== null && _c !== void 0 ? _c : '',
            fixedMonths: (_d = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.fmonths) !== null && _d !== void 0 ? _d : '',
            loadTrainers: (columns === null || columns === void 0 ? void 0 : columns.includes(ECourseColumns.TRAINER)) || fixedColumns.includes(ECourseColumns.TRAINER),
            loadAppointments: [ECourseColumns.APPOINTMENTS, ECourseColumns.APPOINTMENT_LIST].some(function (column) { return (columns === null || columns === void 0 ? void 0 : columns.includes(column)) || fixedColumns.includes(column); }),
            showSearchFilterAfter: (attributes.search.length ? -1 : showSearchFilterAfter),
        };
    }
    var mapDispatchToProps = { getBookEntities: getBookEntities, updatePageNumber: updatePageNumber, setAppState: setAppState, resetBookData: resetBookData, setResolvedColumns: setResolvedColumns, };
    function mergeProps(stateprops, dispatchProps, _a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var attributes = _a.attributes, ownProps = __rest(_a, ["attributes"]);
        var bookData = stateprops.bookData, loading = stateprops.loading, errored = stateprops.errored, hasServerFilters = stateprops.hasServerFilters, columns = stateprops.columns, dirtyFixedColumns = stateprops.fixedColumns, allowedFilters = stateprops.allowedFilters, disableInfo = stateprops.disableInfo, loaderReducer = stateprops.loaderReducer, showSearchFilterAfter = stateprops.showSearchFilterAfter, fixedCourses = stateprops.fixedCourses, fixedPlaces = stateprops.fixedPlaces, fixedMonths = stateprops.fixedMonths, resolvedColumns = stateprops.resolvedColumns, otherStateProps = __rest(stateprops, ["bookData", "loading", "errored", "hasServerFilters", "columns", "fixedColumns", "allowedFilters", "disableInfo", "loaderReducer", "showSearchFilterAfter", "fixedCourses", "fixedPlaces", "fixedMonths", "resolvedColumns"]);
        var bm = getBookDataResponseManager(bookData);
        var entities = (_b = bm === null || bm === void 0 ? void 0 : bm.entities) !== null && _b !== void 0 ? _b : null;
        // const filterValues = attributes;
        var otherProps = {
            records: [],
            filterOptions: [],
            columnHeaders: [],
            hasErrored: errored,
            isLoading: loading,
            totalRecords: (_d = (_c = bm === null || bm === void 0 ? void 0 : bm.pagination) === null || _c === void 0 ? void 0 : _c.total) !== null && _d !== void 0 ? _d : 0,
            showSearchFilter: ((_f = (_e = bm === null || bm === void 0 ? void 0 : bm.pagination) === null || _e === void 0 ? void 0 : _e.total) !== null && _f !== void 0 ? _f : 0) >= showSearchFilterAfter,
        };
        var fixedColumns = __spreadArray(__spreadArray([], dirtyFixedColumns), (resolvedColumns !== null && resolvedColumns !== void 0 ? resolvedColumns : []));
        if (entities) {
            var em = getBookManager(entities, {
                hasServerFilters: hasServerFilters,
                noWaitingList: true,
            });
            var timespansCollection = em.courseTimespans();
            var columnsToRender = getDisplayColumns(columns);
            var fCourses_1 = fixedCourses.split(",").map(function (x) { return x.trim(); }).filter(Boolean);
            var fPlaces_1 = fixedPlaces.split(",").map(function (x) { return x.trim(); }).filter(Boolean);
            var serverCourses = em.courses().filter(function (course) { return fCourses_1.includes(course.name); }).all().map(function (course) { return course.id; });
            assign(otherProps, {
                records: timespansCollection.getRecords({}, columnsToRender, __assign(__assign({ disableInfo: disableInfo }, otherStateProps), { fixedColumns: fixedColumns, fixedCourses: serverCourses, placement: 'course_table', titleKey: 'timespan_format', maxPlacesThreshold: 2 }))
            });
            var allRecords = timespansCollection.getRecords({}, columnsToRender, {
                disableInfo: disableInfo,
                dryRun: true,
                fixedColumns: fixedColumns,
                fixedCourses: serverCourses,
                placement: 'course_table',
                titleKey: 'timespan_format'
            });
            otherProps.columnHeaders = getColumnHeaders(columnsToRender, fixedColumns, allRecords);
            otherProps.filterOptions = timespansCollection.getFilters({}, allowedFilters, {
                courses: em.courses().filter(function (x) { return fCourses_1.includes(x.name); }).all().map(function (x) { return x.id; }),
                places: em.places().filter(function (x) { return fPlaces_1.includes(x.name); }).all().map(function (x) { return x.id; }),
                months: fixedMonths.split(",").map(function (x) { return x.trim(); }).filter(Boolean),
            });
        }
        return __assign(__assign(__assign(__assign(__assign({ disableInfo: disableInfo }, otherStateProps), dispatchProps), ownProps), otherProps), { hasEntities: !!entities, query: ((_g = attributes.search) === null || _g === void 0 ? void 0 : _g.length) ? [].concat(attributes.search).join(',') : undefined, hasFilters: !!(((_h = attributes.search) === null || _h === void 0 ? void 0 : _h.length) || ((_j = attributes.courses) === null || _j === void 0 ? void 0 : _j.length) || ((_k = attributes.places) === null || _k === void 0 ? void 0 : _k.length) || ((_l = attributes.months) === null || _l === void 0 ? void 0 : _l.length)), queryString: qs.stringify(omitBy(__assign({ page: stateprops.pageNumber, perPage: stateprops.pageSize, exclude: 'extra_prices,forms', courses: ((_m = attributes.courses) === null || _m === void 0 ? void 0 : _m.length) ? [].concat(attributes.courses).join(",") : undefined, places: ((_o = attributes.places) === null || _o === void 0 ? void 0 : _o.length) ? [].concat(attributes.places).join(",") : undefined, months: ((_p = attributes.months) === null || _p === void 0 ? void 0 : _p.length) ? [].concat(attributes.months).join(",") : undefined }, omit(qs.parse(stateprops.queryString || ''), 'page', 'exclude', 'perPage')), function (value) { return [undefined, ""].includes(value); })) });
    }
    var Courses = memo(function (_a) {
        var name = _a.name, attributes = _a.attributes, showSearchFilter = _a.showSearchFilter, hasEntities = _a.hasEntities, props = __rest(_a, ["name", "attributes", "showSearchFilter", "hasEntities"]);
        var ref = useRef(null);
        var showCourseAccordion = useShowCourseAccordion();
        var isMobile = useIsMobile();
        var setAppState = props.setAppState, getBookEntities = props.getBookEntities, setResolvedColumns = props.setResolvedColumns, filterPrefix = props.filterPrefix, loadTrainers = props.loadTrainers, loadAppointments = props.loadAppointments;
        var columnHeaders = props.columnHeaders, filterOptions = props.filterOptions, records = props.records, pageNumber = props.pageNumber, pageSize = props.pageSize, totalRecords = props.totalRecords, disableInfo = props.disableInfo, hasFilters = props.hasFilters, _b = props.query, query = _b === void 0 ? "" : _b, resetBookData = props.resetBookData;
        var parsedParams = qs.parse(props.queryString || '');
        var include = [].concat(loadAppointments ? "appointments" : [], loadTrainers ? "trainer" : []).join(",") || undefined;
        var querystring = qs.stringify(__assign({ exclude: 'extra_prices,forms', include: include }, parsedParams));
        var isTable = useIsCurrentState(APP_STATE.TABLE);
        var hadQuery = useHadQuery();
        useEffect(function () {
            setAppState(APP_STATE.TABLE);
        }, [setAppState]);
        var normalizedColumnHeaders = columnHeaders.map(function (x) { return x.key; }).join(",");
        useEffect(function () {
            ref.current && scrollToRef(ref);
        }, [pageNumber, pageSize]);
        useEffect(function () {
            if (!hasEntities)
                return;
            setResolvedColumns(normalizedColumnHeaders);
        }, [hasEntities, normalizedColumnHeaders]);
        useEffect(function () {
            if (!hasEntities)
                return;
            return function () {
                setResolvedColumns("", true);
            };
        }, []);
        var courseTableCancelToken = useState(function () { return cancelToken(name + "course-table"); })[0];
        useDebouncedQuery(function (debouncedQueryString) {
            getBookEntities(qs.stringify(__assign(__assign({}, qs.parse(debouncedQueryString)), (query ? { query: query } : {}))), {
                resetAllPages: true,
                reset: true,
                cancelToken: courseTableCancelToken,
            });
        }, querystring, query);
        useEffect(function () { return function () {
            resetBookData(true);
        }; }, [resetBookData]);
        if (!isTable)
            return null;
        if (props.hasErrored)
            return null;
        if (props.isLoading && !hadQuery && !hasFilters && !records.length) {
            return React.createElement(Loader, null);
        }
        if (!records.length && !hadQuery && !hasFilters && !records.length) {
            return React.createElement(NoDataToDisplay, null);
        }
        var updateFilters = function () {
            props.updatePageNumber(1);
        };
        var renderCourseMeta = function () {
            if (disableInfo)
                return null;
            return (React.createElement(CourseMeta, { filterValues: {}, placement: "course_table", titleKey: "timespan_title", defaultTitle: "course_table.title", paginated: true }));
        };
        var renderCourses = function () {
            if (props.isLoading && !hasFilters)
                return React.createElement(Loader, null);
            if (!records.length)
                return React.createElement(NoDataToDisplay, null);
            if (showCourseAccordion)
                return React.createElement(CourseAccordion, { columnHeaders: columnHeaders, records: records });
            return React.createElement(CourseTable, { columnHeaders: columnHeaders, records: records });
        };
        return (React.createElement(CoursesDiv, { ref: ref },
            React.createElement(React.Fragment, null, renderCourseMeta()),
            React.createElement(CourseFilters, { stacked: isMobile, onUpdate: updateFilters, filterOptions: filterOptions, filterPrefix: filterPrefix, showSearchFilter: showSearchFilter }),
            React.createElement(React.Fragment, null, renderCourses()),
            React.createElement(StyledPoweredBy, { canBeFloating: props.totalRecords > pageSize },
                React.createElement(Pagination, { pageNumber: pageNumber, pageSize: pageSize, totalRecords: totalRecords }))));
    });
    var Component = connect(mapStateToProps, mapDispatchToProps, mergeProps, isBookDataUpdated("bookData"))(Courses);
    return {
        Component: Component,
        ComponentWrapped: function (props) { return React.createElement(AppBootstrapComponent, __assign({}, props, { Component: Component })); }
    };
};
export var Courses = (_a = courseFactory(function () { return useIsMobile(); }), _a.Component), CoursesWrapped = _a.ComponentWrapped;
export var CourseAccordionWrapped = courseFactory(function () { return true; }).ComponentWrapped;
export var CourseTableWrapped = courseFactory(function () { return false; }).ComponentWrapped;
var CoursesDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var StyledPoweredBy = function StyledPoweredBy(props) {
    var ref = useRef(null);
    var _a = useState(undefined), style = _a[0], setStyle = _a[1];
    var setFloating = useCallback(function (width) {
        setStyle(width < 600 ? undefined : { position: 'absolute', marginTop: 0, left: "50%", transform: "translateX(-50%)", bottom: 0, });
    }, []);
    /**
     * Handle Resize
     */
    useEffect(function () {
        if (!("ResizeObserver" in window))
            return;
        if (!props.canBeFloating) {
            setStyle(undefined);
            return;
        }
        var el = ref.current;
        if (el === null)
            return;
        var resizeobserver = new ResizeObserver(function (entries) {
            setFloating(entries[0].contentRect.width);
        });
        resizeobserver.observe(el);
        return function () {
            resizeobserver.disconnect();
        };
    }, [setFloating, props.canBeFloating]);
    useLayoutEffect(function () {
        if (!ref.current)
            return;
        if (!props.canBeFloating)
            return;
        setFloating(ref.current.getBoundingClientRect().width);
    }, [setFloating, props.canBeFloating]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref }),
        React.createElement(PoweredByWrapper, { style: props.canBeFloating ? style : undefined, right: false }, props.children)));
};
var templateObject_1;
